module.exports = __webpack_public_path__ + "img/ig.632701c5.png";